var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eu-select-add"},[_c('div',{staticClass:"pos"},[_c('div',{staticClass:"operate"},[_c('i',{staticClass:"el-icon-plus"}),_vm._v("  "+_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }